
// --- Vue & Template imports ---
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

// --- Third Party imports ---
import colors from 'vuetify/lib/util/colors';


@Component
export default class SideDrawerHeader extends Vue {
  @Prop(String) readonly openSideMenuIcon!: string;
  @Prop(String) readonly closeSideMenuIcon!: string;
  @Prop(String) readonly openSideMenuIconMobile!: string;
  @Prop(String) readonly closeSideMenuIconMobile!: string;
  @Prop(Boolean) readonly defaultOpen!: boolean;
  @Prop(Boolean) readonly allowToggle!: boolean;
  @Prop(String) readonly textColor!: string;
  @Prop(String) readonly hoverColor!: string;
  @Prop(String) readonly hoverTextColor!: string;
  @Prop(String) readonly activeColor!: string;
  @Prop(String) readonly activeTextColor!: string;
  @Prop(Boolean) readonly mobileOnly!: boolean;

  toggleSideDrawer() {
    if (this.$vuetify.breakpoint.mdAndDown || this.allowToggle || this.mobileOnly) {
      this.$root.$emit('toggleSideDrawer');
    }
  }

  getColor(colorString: string) {
    if (colorString.indexOf('#') > -1) {
      return colorString;
    }

    if (this.$vuetify.theme.currentTheme) {
      for (const [colorIndex, color] of Object.entries(this.$vuetify.theme.currentTheme)) {
        if (colorString === colorIndex) {
          return color + '';
        }
      }
    }

    if (colors) {
      for (const [colorIndex, color] of Object.entries(colors)) {
        if (colorString === colorIndex) {
          return color.base + '';
        }
      }
    }

    return colorString;
  }
}
